

export const apiConfig = {
    events: {
        add: "events"
    }
};
